"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var styles_1 = require("@mui/material/styles");
var LogoImg_1 = __importDefault(require("atomicComponents/atoms/Logo/LogoImg"));
var PREFIX = 'Tool';
var classes = {
    wrapper: "".concat(PREFIX, "-wrapper"),
    avatar: "".concat(PREFIX, "-avatar"),
    placeholder: "".concat(PREFIX, "-placeholder"),
};
var StyledBox = (0, styles_1.styled)(material_1.Box)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b["&.".concat(classes.wrapper)] = {
            border: "1px solid ".concat(theme.palette.grey[400]),
            borderRadius: 10,
        },
        _b[".".concat(classes.placeholder)] = {
            borderRadius: 12,
            backgroundColor: theme.palette.grey[500],
        },
        _b);
});
var Tool = function () { return ((0, jsx_runtime_1.jsxs)(StyledBox, __assign({ display: "flex", p: 2, className: classes.wrapper }, { children: [(0, jsx_runtime_1.jsx)(LogoImg_1.default, { size: "sm", src: "/tool-placeholder.svg" }), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ display: "flex", flexDirection: "column", justifyContent: "space-around", ml: 1.5 }, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, { className: classes.placeholder, height: 8, width: 120 }), (0, jsx_runtime_1.jsx)(material_1.Box, { className: classes.placeholder, mt: 1, height: 8, width: 84 })] }))] }))); };
exports.default = Tool;
